import merge from 'deepmerge';

export const validateTrackingCategoriesEditForm = (values, requiredFields) => {
  let errors = {};

  requiredFields.forEach(field => {
    const keys = field.split('.');
    let value = keys.reduce((prevKey, currentKey) => prevKey && prevKey[currentKey], values);

    if (typeof value === 'string') {
      value = value.trim();
    }

    if (!value) {
      const error = keys.reduceRight((prevVal, currentKey) => {
        return prevVal ?
          { [currentKey]: prevVal } : { [currentKey]: 'Required' };

      }, null);
      errors = merge(errors, error);
    }
  });
  return errors;
};

